var map = {
	"./blue/lotto/lucky-3-en.png": 7151,
	"./blue/lotto/lucky-4-en.png": 6728,
	"./blue/lotto/lucky-5-en.png": 4027,
	"./darkblue/lotto/lucky-3-en.png": 6672,
	"./darkblue/lotto/lucky-4-en.png": 8365,
	"./darkblue/lotto/lucky-5-en.png": 1134,
	"./orange/lotto/lucky-3-en.png": 8880,
	"./orange/lotto/lucky-4-en.png": 7619,
	"./orange/lotto/lucky-5-en.png": 7219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5856;